import Events from '_utils/events';
import EquipmentService from '_services/rest/modules/equipment';

export default {
  data() {
    return {
      loading: false,
      instruments: [],
      calibrators: [],
    };
  },
  methods: {
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    async getListEquipments(category, typeMap) {
      try {
        this.toggleLoading();
        const params = {
          skip: 0,
          take: 10,
          search: null,
          type: typeMap[category],
          all: true,
        };
        const response = await EquipmentService.getList(params);
        this[category] = response;
      } finally {
        this.toggleLoading();
      }
    },
    setEquipmentData(prefix) {
      const equipment = this.model[`${prefix}_object`];
      this.model[`${prefix}`] = equipment?.name || null;
      this.model[`${prefix}_serie`] = equipment?.serial_number || null;
      this.model[`${prefix}_certificate`] =
        equipment?.calibration_certificate || null;
      this.model[`${prefix}_validity`] = equipment?.expiration_date || null;
    },
  },
};
